module.exports = __webpack_public_path__ + "img/wood-still-icon.5009ec11.svg";